<template>
	<div class="home">
		<Sheet />
	</div>
</template>

<script>
// @ is an alias to /src
import Sheet from '@/components/Sheet.vue'

export default {
	name: 'Home',
	components: {
		Sheet
	}
}
</script>
